<template>
  <div>
    <p><router-link :to="{name: 'home'}">Домашня сторінка</router-link> &raquo; Трекер відвідуваності</p>

    <div v-if="attendance === undefined"><i>Завантаження...</i></div>

    <div v-if="attendance !== undefined">
      <h1>{{ title }}</h1>

      <p><b>Дата:</b> {{ this.currentDate }}</p>

      <div v-if="!(currentDate in attendance)">
        <p>сьогодні немає школи!</p>
        <button v-for="previousDate in previousDates" @click="setDate(previousDate)" class="btn btn-outline-dark"><icon name="book"></icon>Минула дата {{ previousDate }}</button>
      </div>

      <div v-if="currentDate in attendance && upcomingBirthdays.length > 0">
        <p><b>Найближчі дні народження:</b></p>
        <ul>
          <div v-for="studentNumber in upcomingBirthdays">
            <li>{{ students[studentNumber].child_name }} ({{ students[studentNumber].child_birthdate }})</li>
          </div>
        </ul>
      </div>

      <div v-for="(attendance, studentNumber) in attendance[currentDate]" class="card" style="width: 100%; margin-bottom: 10px" v-if="attendance != '/'">
        <div class="card-body">
          <h3 class="card-title">{{ students[studentNumber].child_name }}</h3>
          <div v-if="students[studentNumber].time_slot != ''"><icon name="star"></icon> {{ students[studentNumber].time_slot }}</div>
          <div v-if="students[studentNumber].child_birthdate != ''"><icon name="calendar"></icon> {{ students[studentNumber].child_birthdate }}</div>
          <div v-if="students[studentNumber].parents_name != ''"><icon name="user"></icon> {{ students[studentNumber].parents_name }}</div>
          <div v-if="students[studentNumber].phone_number != ''"><icon name="phone"></icon> <a :href="'tel:' + students[studentNumber].phone_number">{{ students[studentNumber].phone_number }}</a></div>
          <div v-if="students[studentNumber].comment != ''"><icon name="comment"></icon> {{ students[studentNumber].comment }}</div>
        </div>
        <div class="card-footer">
          <b-button-group>
            <b-button :variant="attendance == '*' ? 'success' : ''" @click="setAttendance(currentDate, studentNumber, '*')">присутній</b-button>
            <b-button :variant="attendance == '-' ? 'warning' : ''" @click="setAttendance(currentDate, studentNumber, '-')">Відсутній</b-button>
          </b-button-group>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import 'vue-awesome/icons/phone'
import 'vue-awesome/icons/calendar'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/comment'
import 'vue-awesome/icons/star'

import AWS from 'aws-sdk'

function parseDate (dateString, userFormat) {
  var delimiter, theFormat, theDate, month, date, year
  // Set default format if userFormat is not provided
  userFormat = userFormat || 'yyyy-mm-dd'

  // Find custom delimiter by excluding
  // month, day and year characters
  delimiter = /[^dmy]/.exec(userFormat)[0]

  // Create an array with month, day and year
  // so we know the format order by index
  theFormat = userFormat.split(delimiter)

  // Create an array of dateString.
  theDate = dateString.split(delimiter)
  for (var i = 0, len = theDate.length; i < len; i++) {
    // assigning values for date, month and year based on theFormat array.
    if (/d/.test(theFormat[i])) {
      date = theDate[i]
    } else if (/m/.test(theFormat[i])) {
      month = parseInt(theDate[i], 10) - 1
    } else if (/y/.test(theFormat[i])) {
      year = parseInt(theDate[i])
      if (year < 100) {
        year += 2000
      }
    }
  }
  return (new Date(year, month, date))
}

export default {
  name: 'attendance',
  data: function () {
    return {
      title: undefined,
      currentDate: undefined,
      dates: undefined,
      previousDates: undefined,
      students: undefined,
      attendance: undefined,
      upcomingBirthdays: undefined
    }
  },
  methods: {
    async setDate (date) {
      this.currentDate = date
    },
    async setAttendance (date, studentNumber, attendance) {
      try {
        const currentAttendance = this.attendance[date][studentNumber]
        const newAttendance = (currentAttendance === attendance) ? '' : attendance // allow toggling attendance off

        this.attendance[date][studentNumber] = newAttendance

        if (this.$store.getters.isOAuth2TokenExpired) {
          await this.$store.dispatch('refreshCodeGrant')
        }

        const lambda = new AWS.Lambda({
          credentials: await this.$store.getters.awsCredentials,
          region: process.env.AWS_REGION
        })

        const lambdaResult = await lambda.invoke({
          FunctionName: process.env.LAMBDA_FUNCTION_ARN,
          Payload: JSON.stringify({
            action: 'set_attendance',
            params: {
              title: this.title,
              date: date,
              student_number: studentNumber,
              attendance: newAttendance
            },
            cognito_userinfo: await this.$store.getters.userInfo
          })
        }).promise()

        const worksheet = JSON.parse(lambdaResult.Payload)

        if ('errorMessage' in worksheet) {
          throw new Error(JSON.stringify(worksheet, undefined, 2))
        }
      } catch (error) {
        this.$router.push({ name: 'error', params: { message: error.message } })
        return
      }
    }
  },
  async created () {
    try {
      this.title = this.$route.params.title

      if (this.$store.getters.isOAuth2TokenExpired) {
        await this.$store.dispatch('refreshCodeGrant')
      }

      const lambda = new AWS.Lambda({
        credentials: await this.$store.getters.awsCredentials,
        region: process.env.AWS_REGION
      })

      const lambdaResult = await lambda.invoke({
        FunctionName: process.env.LAMBDA_FUNCTION_ARN,
        Payload: JSON.stringify({
          action: 'get_worksheet',
          params: {
            title: this.title
          },
          cognito_userinfo: await this.$store.getters.userInfo
        })
      }).promise()

      const worksheet = JSON.parse(lambdaResult.Payload)

      if ('errorMessage' in worksheet) {
        throw new Error(JSON.stringify(worksheet, undefined, 2))
      }

      const date = new Date()

      this.dates = worksheet.body.dates

      var previousDates = []
      for (const dateString of worksheet.body.dates) {
        const parsedDate = parseDate(dateString, 'dd.mm.yy')
        if (parsedDate < date) {
          previousDates.push(dateString)
        }
      }
      this.previousDates = previousDates.slice(-3)
      this.currentDate = date.getDate() + '.' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '.' + (date.getFullYear() % 100)

      var upcomingBirthdays = []
      for (const studentObject of Object.entries(worksheet.body.students)) {
        const studentId = studentObject[0]
        const student = studentObject[1]

        const birthdayThisYear = parseDate(student.child_birthdate, 'dd/mm/yyyy')
        birthdayThisYear.setFullYear(date.getFullYear())
        const differenceInDays = Math.floor((birthdayThisYear - date) / (1000 * 60 * 60 * 24))
        if (differenceInDays >= 0 && differenceInDays <= 21) { // negative values for differenceInDays mean the birthday has already passed
          upcomingBirthdays.push(studentId)
        }
      }
      this.upcomingBirthdays = upcomingBirthdays

      this.students = worksheet.body.students
      this.attendance = worksheet.body.attendance
    } catch (error) {
      this.$router.push({ name: 'error', params: { message: error.message } })
      return
    }
  }
}
</script>



// WEBPACK FOOTER //
// Attendance.vue?4f10fada